import classNames from 'classnames'; // Import css modules stylesheet as styles
import * as React from 'react';
import { IInputConfig } from '../index';
import { InputRadioOption } from './InputRadioOption';

interface IProps {
  radioOptions?: IInputConfig[];
  forcedValue?: string;
  readOnly?: boolean;
  radioExtraStyles?: string;
  checked?: boolean;
}

export function InputRadio(props: IProps) {
  // eslint-disable-next-line
  const [focused, setFocused] = React.useState(false);

  const options = props.radioOptions.map((input: IInputConfig, i: number) => (
    <InputRadioOption
      key={input.id}
      input={input}
      index={i}
      readOnly={props.readOnly}
      defaultChecked={input.defaultChecked}
      checked={props.checked || props.forcedValue == input.value}
      forcedValue={input.value}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      disabled={input.disabled}
      radioExtraStyles={props.radioExtraStyles}
    />
  ));

  return <ul className={classNames('radioWrapper')}>{options}</ul>;
}
